module.exports = __webpack_public_path__ + "static/media/equipos.7cccd41e.png";